import './style.scss';
import documentHomeIcon from '../../../../assets/images/document-home-icon.png';
import { ContactUsTips } from '../../../component/contact-us-tips';
import { IProjectDocInfo } from '../../../../model/api-modules/document';
import { LanguageType } from '../../../../model';
import { LanguageType as langType } from '../../../../lib';
import getFormatMessage from '../../../../locales/get-format-message';
// import { getConfig } from '../../../../config';

interface IProps {
  readonly isDocPublicRoute: boolean;
  readonly projectDocInfo: IProjectDocInfo | undefined;
  readonly lang: LanguageType | null;
}

export const DocumentHomeLeft = (props: IProps) => {
  const lang = props.lang === LanguageType.ZH ? langType.zh_CN : langType.en_US;

  const onToStartedPage = (isStarted?: boolean) => {
    const menu = props?.projectDocInfo?.menu.filter(
      (menu) => menu.name === '入门指南' || menu.name === 'Get Started'
    );
    if (menu) {
      // product 跳转
      const getStartedItem = menu[0]?.nodes.filter(
        (menu) => menu.name === 'Services' || menu.name === '服务概览'
      );
      const getStartedId = getStartedItem[0]?.id;
      // getStarted 跳转
      const getToGuideItem = menu[0]?.nodes.filter(
        (menu) => menu.name === 'How-to Guide' || menu.name === '使用指南'
      );
      const getToGuideId = getToGuideItem[0]?.id;
      const urlId = isStarted ? getToGuideId : getStartedId;
      const currentUrl = window.location.href;
      if (urlId) {
        const newUrl = `${currentUrl}/${urlId}`;
        window.open(newUrl, '_self');
      }
    }
  };

  return (
    <div className="document-home-left">
      <div className="home-left-title">
        <div className="home-left-title-one">InGame</div>
        <div className="home-left-title-two">
          {getFormatMessage('documentation_portal', {}, lang)}
        </div>
        <div className="home-left-btn">
          <div
            className="home-left-btn-left"
            onClick={() => onToStartedPage(true)}
          >
            {getFormatMessage('document_get_started', {}, lang)}
          </div>
          <div
            className="home-left-btn-right"
            onClick={() => onToStartedPage()}
          >
            {getFormatMessage('document_product', {}, lang)}
          </div>
        </div>
      </div>
      <img src={documentHomeIcon} className="home-left-img" />
      <div className="home-left-bottom-box">
        <div className="home-left-describe">
          {getFormatMessage('document_home_des', {}, lang)}
        </div>
        <ContactUsTips
          languageType={
            props.lang === LanguageType.ZH ? langType.zh_CN : langType.en_US
          }
        />
      </div>
    </div>
  );
};
